import { LotQuery } from 'components/pages/LotBasePage/types/lotQuery'
import React from 'react'
import classNames from 'classnames'

type Props = {
  notice: NonNullable<LotQuery['lot']>['notice']
  className?: string
  variant?: 'gray' | 'transparent'
}
const Notice = ({ notice, className, variant = 'gray' }: Props) => {
  if (!notice.present) return null

  if (variant === 'transparent') {
    return (
      <div className={classNames('text-white transparent-notice', className)}>
        <div className="mx-auto max-w-screen-md lg:max-w-7xl px-8 py-4 sm:py-8">
          <div
            className="prose prose-sm md:prose-base max-w-none text-white"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: notice.html }}
          />
        </div>
      </div>
    )
  }
  return (
    <div
      className={classNames(
        'bg-gradient-to-r from-orange-50 to-orange-100 sm:to-orange-200 border-l-4 border-orange-400 border-solid',
        className
      )}
    >
      <div className="mx-auto max-w-screen-md lg:max-w-7xl px-8 py-4 sm:py-8">
        <div
          className="prose prose-sm md:prose-base max-w-none"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: notice.html }}
        />
      </div>
    </div>
  )
}

export default Notice
